module.exports = __webpack_public_path__ + "img/heywin.c2a95f8e.svg";